"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useInfiniteLoadingRepCodes = void 0;
const ramda_1 = require("ramda");
const react_query_1 = require("@tanstack/react-query");
const utils_1 = require("./utils");
const sleep = (ms = 1000) => new Promise((resolve) => setTimeout(resolve, ms));
const useInfiniteLoadingRepCodes = (apiUrl, httpClient, widgetId, search, enabled = true, offset = 20) => {
    const { data: repCodes, error, isFetching, fetchNextPage, fetchPreviousPage, hasNextPage, hasPreviousPage, refetch } = (0, react_query_1.useInfiniteQuery)({
        queryKey: [search, widgetId, apiUrl],
        queryFn: (_a) => __awaiter(void 0, [_a], void 0, function* ({ pageParam = 1, signal }) {
            new AbortController().abort();
            const baseQueryParams = { Page: pageParam, PageSize: offset };
            const queryParams = !(0, ramda_1.isEmpty)(search) ? Object.assign(Object.assign({}, baseQueryParams), { Text: search }) : baseQueryParams;
            yield sleep(500);
            return httpClient(`${apiUrl}/user/rep-codes`, {
                signal,
                traceId: widgetId,
                params: { queryParams }
            });
        }),
        getPreviousPageParam: (firstPage) => {
            if (firstPage.page >= 2) {
                return firstPage.page - 1;
            }
            return undefined;
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.page < lastPage.totalPages) {
                return lastPage.page + 1;
            }
        },
        enabled
    });
    const repCodesStructure = repCodes === null || repCodes === void 0 ? void 0 : repCodes.pages.reduce((acc, codes) => [...acc, ...(0, utils_1.convertedRepCodesOptions)(codes.items)], []);
    const totalItems = repCodes === null || repCodes === void 0 ? void 0 : repCodes.pages[0].totalItems;
    return {
        repCodes: repCodesStructure,
        isLoadingRepCodes: isFetching,
        fetchNextPage,
        hasPreviousPage,
        hasNextPage,
        refetch,
        totalItems,
        fetchPreviousPage,
        error
    };
};
exports.useInfiniteLoadingRepCodes = useInfiniteLoadingRepCodes;
